export default __webpack_public_path__ + "img/eLwLEmIm.bb863af8.svg";